import AvatarDefaultIcon from '@assets/images/avatar/default.png';
import { useCompanyAuth } from '@src/context/auth/useCompanyAuth';
import { useUserNavigation } from '@src/context/UserNavigationContext';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const CompanyAccountMenu = () => {
  const [isMenuShow, setIsMenuShow] = useState(false);
  const { menuLinks } = useUserNavigation();
  const context = useCompanyAuth();
  const navigate = useNavigate();

  const handleClickAccountMenu = () => {
    setIsMenuShow((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest('[data-account-menu]')) {
        setIsMenuShow(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  return (
    <div className='relative'>
      <button
        type='button'
        onClick={handleClickAccountMenu}
        className='flex w-full items-center gap-4 pl-5 text-left text-black transition-opacity hover:opacity-70'
        data-account-menu
      >
        <img
          className='size-6 rounded-full object-cover'
          src={context.profile?.user?.avatarUrl || AvatarDefaultIcon}
          alt=''
          width='24'
          height='24'
        />
        <p className='grow truncate'>
          <span className='block truncate'>{`${context?.profile?.user?.familyName || ''} ${context?.profile?.user?.firstName || ''}`}</span>
        </p>
        <div className='grid size-[60px] flex-[0_0_auto] place-items-center'>
          <div className='h-[5px] w-[10px] bg-current [clip-path:polygon(50%_100%,0_0,100%_0)]'></div>
        </div>
      </button>
      {isMenuShow && (
        <div
          className='absolute left-0 top-full w-full overflow-hidden rounded-md border border-gray-200 bg-white text-sm'
          data-account-menu
        >
          <div className='flex flex-col gap-px bg-gray-200'>
            {menuLinks.map((link) => (
              <div
                className='cursor-pointer bg-white px-6 py-[15px] transition-colors hover:bg-primary-500 hover:text-white'
                onClick={() => navigate(link.link)}
                role='button'
                tabIndex={0}
                key={link.link}
              >
                { link.title }
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CompanyAccountMenu;
